<template>
  <ValidationObserver
    ref="textareaObserver"
    :style="cssVars" >
    <ValidationProvider
      ref="textareaProvider"
      v-slot="{ errors, failedRules }"
      :name="schema.title"
      :rules="validators">
      <SBTextInput
        ref="messageArea"
        :focus-shadow="true"
        :placeholder="placeholder"
        :show-tags-select="false"
        :hide-tools="schema.hideTools"
        hide-send-button
        @input="textValueSync"
        @raw-input="rawInputSync" />
      <div
        v-if="schema.subtitle && !errors[0]"
        class="subtitle flex flex-align-center">
        <SBIcon
          v-if="schema.subtitlePrefixIcon"
          class="mr-1"
          :icon="schema.subtitlePrefixIcon"
          :color="SBColors.greyLight"
          :size="10" />
        <span>{{ schema.subtitle }}</span>
      </div>
      <!-- <div
        v-if="errors[0]"
        class="error flex flex-align-center">
        <SBIcon
          class="mr-2"
          :icon="SBIconList.ERROR"
          :color="SBColors.redPrimary"
          :size="10" />
        <span>{{ schema.validatorMessages && schema.validatorMessages[Object.keys(failedRules)[0]] ? schema.validatorMessages[Object.keys(failedRules)[0]] : errors[0] }}</span>
      </div> -->
      <div
        v-if="errors[0]"
        class="error flex flex-align-center"
        :class="{ warning: warningValidators.includes(Object.keys(failedRules)[0])}">
        <SBIcon
          class="mr-1"
          :icon="warningValidators.includes(Object.keys(failedRules)[0]) ? SBIconList.INFO : SBIconList.ERROR"
          :color="warningValidators.includes(Object.keys(failedRules)[0]) ? '#DEBD30' : SBColors.redPrimary"
          :size="10" />
        <span>{{ schema.validatorMessages && schema.validatorMessages[Object.keys(failedRules)[0]] ? schema.validatorMessages[Object.keys(failedRules)[0]] : errors[0] }}</span>
      </div>
    </ValidationProvider>
  </ValidationObserver>
</template>

<script>
import SBColors from '@/helpers/lists/colors';
import SBIcon from '@/components/common/Icon';
import SBIconList from '@/helpers/lists/sb-icon-list';
import SBTextInput from '@/components/business/widgets/SBTextInput';
import { whatsappFormatMessage } from '@/helpers/stringHelpers';

export default {
  name: 'SBTextareaWrapper',
  components: {
    SBIcon,
    SBTextInput,
  },
  props: {
    placeholder: {
      type: String,
      default: '',
    },
    validators: {
      type: String,
      default: '',
    },
    schema: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      textValue: '',
      rawInput: '',
      SBColors,
      SBIconList,
    };
  },
  computed: {
    cssVars() {
      if (!this.schema.height) return {};
      // if (!this.schema.height) {
      //   return {
      //     '--height': '60px',
      //   };
      // }
      // return {};
      return {
        '--textHeight': `${this.schema.height + (this.schema.hideTools ? 0 : 36)}px`,
        '--editorHeight': `${this.schema.height}px`,
      };
    },
    warningValidators() {
      return this.schema.warningValidators ? this.schema.warningValidators.split(',') : [];
    },
  },
  watch: {
    textValue: {
      handler() {
        this.emitData();
      },
      immediate: true,
    },
    // rawInput: {
    //   handler() {
    //     this.emitData();
    //   },
    //   immediate: true,
    // },
  },
  mounted() {
    if (this.schema.value) {
      this.$refs.messageArea.setText(this.schema.value);
    }
    if (this.schema.stepID) {
      this.$eventBus.$on(`validate-${this.schema.stepID}`, () => {
        if (this.$refs.textareaObserver) this.$refs.textareaObserver.validate();
      });
    }
    setTimeout(() => {
      this.emitData(true);
      if (this.schema.value) {
        if (this.$refs.textareaObserver) this.$refs.textareaObserver.validate();
      }
    }, 0);
  },
  methods: {
    textValueSync(textValue) {
      this.textValue = textValue;
    },
    rawInputSync(rawInput) {
      // console.log('rawInputSync', rawInput);
      this.rawInput = rawInput;
      this.$refs.textareaProvider.syncValue(this.rawInput);
    },
    onlyWarnings() {
      const fields = Object.values(this.$refs.textareaObserver.fields).map(field => Object.keys(field.failedRules)).flat(Infinity);
      const someTest = fields.length ? !fields.some(failed => !this.warningValidators.includes(failed)) : false; // if there are no fields, return false because it means the field is validated silently and no failedRules are being recorded
      return someTest;
    },
    emitData(reset = false) {
      // console.log(1);
      if (!this.$refs.textareaObserver) return;
      // console.log(2);
      this.$refs.textareaObserver.validate({ silent: false })
        .then((valid) => {
          // console.log(3, valid);
          this.$emit('input', {
            valid: valid || this.onlyWarnings(),
            name: this.schema.returnKey || '',
            data: {
              value: whatsappFormatMessage(this.textValue).trim(),
            },
          });
        })
        .finally(() => {
          if (reset) this.$refs.textareaObserver.reset();
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.avatar-select {
  position: absolute;
  top: 1px;
  left: 1px;
  border-radius: 10px 0 0 10px !important;
  z-index: 1;
}

.indent {
  padding-left: 50px !important;
}

::v-deep .text-input-wrapper {
  border-radius: 10px !important;
  min-height: unset !important;
}

::v-deep {
  .text-input-wrapper {
    min-height: var(--textHeight) !important;
    // max-height: calc(var(--height) + 36px) !important;

    #vue-editor-wrapper {
      min-height: var(--editorHeight) !important;
      // max-height: var(--height) !important;
    }
  }
}
</style>
